import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResourceRoutingModule } from './resource-routing.module';
import { ResourcesComponent } from './components/resources/resources.component';
import { GtapMaterialsModule } from '../gtap-materials/gtap-materials.module';


@NgModule({
  declarations: [ResourcesComponent],
  imports: [
    CommonModule,
    GtapMaterialsModule,
    ResourceRoutingModule
  ]
})
export class ResourceModule { }
